"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_RECEIPT_FILE = exports.GET_CURRENCY = exports.GET_RECEIPTS = exports.GET_RECEIPT_PAYMENT_CONFIRMATION_DETAILS = exports.GET_RECEIPT = void 0;
exports.GET_RECEIPT = `
  query getReceipt($invoiceId: String, $legalEntity: String) {
    getReceipt(invoiceId: $invoiceId, legalEntity: $legalEntity){ 
      id
      invoiceDate
      amount
      balance
      invoiceNumber
      accountId
      currency
      legalEntity
    }
  }
`;
exports.GET_RECEIPT_PAYMENT_CONFIRMATION_DETAILS = `
  query getReceiptPaymentConfirmationDetails($invoiceId: String) {
    getReceiptPaymentConfirmationDetails(invoiceId: $invoiceId){
      id
      invoiceDate
      amount
      balance
      invoiceNumber
      accountId
      paymentDate
    }
  }
`;
exports.GET_RECEIPTS = `
  {
    getReceipts {
      invoiceDate
      amount
      invoiceNumber
      id
      status
      dueDate
      legalEntity
      InvoiceType__c
      balance
      DueDateOverride__c
      currency
    }
  }
`;
exports.GET_CURRENCY = `
  {
    getCurrency {
      latestCurrency
      latestEntity
      entities
    }
  }
`;
exports.GET_RECEIPT_FILE = `
    query getReceiptFile($invoiceId: String, $legalEntity: String) {
      getReceiptFile(invoiceId: $invoiceId, legalEntity: $legalEntity)
    }
`;
//# sourceMappingURL=receipts-queries.js.map